'use strict';

const isInstanceOf = require('../rlink-type-utils/isInstanceOf');

module.exports = function arrayShape (shapeCheckers, ...args) {
  let checker = (obj, key, cname, location, fullName) => {
    let value = obj[key];
    if (!isInstanceOf(value, Array)) {
      return new TypeError(`Value at ${fullName} is not an array.`);
    }
    if (value.length !== shapeCheckers.length) {
      return new TypeError(`Array shape length at ${cname}:${location}:${fullName} does not match. Expected length ${shapeCheckers.length}, got ${value.length} for ${JSON.stringify(value)}`);
    }
    for (let [idx, memberChecker] of shapeCheckers.entries()) {
      let check = memberChecker(value, idx, cname, location, `${fullName}[${idx}]`);
      if (check) {
        return check;
      }
    }
  };
  checker.getCheckerForKey = idx => shapeCheckers[idx];
  checker.makeNew = () => [];
  checker.checkerName = 'arrayShape';

  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (!Array.isArray(shapeCheckers)) {
    throw new Error(`Invalid argument type to ${checker.checkerName}: ${shapeCheckers}`);
  }
  for (let [key, keyChecker] of shapeCheckers.entries()) {
    if (typeof keyChecker !== 'function') {
      throw new Error(`Invalid checker at ${key} for ${checker.checkerName}: ${keyChecker}`);
    }
    if (!keyChecker.checkerName) {
      throw new Error(`Non-rlink-shape checker at ${key} for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
    }
  }
  return checker;
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/arrayShape.js